/* ==========================================================
   ASK CHAT
========================================================== */

document.addEventListener("DOMContentLoaded", () => {

  const chat = document.getElementById("ask-chat");
  if (!chat) return;

  const toggle = chat.querySelector(".ask-chat__toggle");
  const panel = chat.querySelector(".ask-chat__window");
  const close = chat.querySelector(".ask-chat__close");
  const services = chat.querySelectorAll(".ask-chat__service");
  const cta = chat.querySelector(".ask-chat__cta");

  const phone = chat.dataset.phone;

  panel.hidden = true;

  function openAskChat() {
    panel.hidden = false;
    toggle.setAttribute("aria-expanded", "true");
  }

  function closeAskChat() {
    panel.hidden = true;
    toggle.setAttribute("aria-expanded", "false");
  }

  function toggleAskChat() {
    if (panel.hidden) {
      openAskChat();
    } else {
      closeAskChat();
    }
  }

  toggle.addEventListener("click", toggleAskChat);

  close.addEventListener("click", closeAskChat);

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      closeAskChat();
    }
  });

  services.forEach(button => {

    button.addEventListener("click", () => {

      const service = button.dataset.service;

      const message = encodeURIComponent(
`Hi ASK!

I'm interested in your ${service} services.

I'd like to discuss my project.`
      );

      window.open(
        `https://wa.me/${phone}?text=${message}`,
        "_blank"
      );

    });

  });

  cta.addEventListener("click", () => {

    const message = encodeURIComponent(
      "Hi ASK! I'd like to discuss my project."
    );

    window.open(
      `https://wa.me/${phone}?text=${message}`,
      "_blank"
    );

  });

  /* Global API */

  window.openAskChat = openAskChat;
  window.closeAskChat = closeAskChat;
  window.toggleAskChat = toggleAskChat;

});